module.exports = __webpack_public_path__ + "shutterstock_615536654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/homeSlider/shutterstock_615536654.jpg
// module id = 905
// module chunks = 0